import { render, staticRenderFns } from "./FriendBox.vue?vue&type=template&id=74a90966&"
import script from "./FriendBox.vue?vue&type=script&lang=js&"
export * from "./FriendBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports